import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/components/ui/use-toast';

interface ReportData {
  content_type: string;
  reported_content: string;
  reason: string;
  reported_user_id: string;
  content_id: string;
}

export function useReports() {
  const createReport = async (data: ReportData) => {
    try {
      // Obtener el usuario actual
      const { data: session } = await supabase.auth.getSession();
      if (!session?.session?.user) {
        throw new Error('No hay sesión de usuario');
      }

      const { error } = await supabase
        .from('content_reports')
        .insert([{
          reporter_id: session.session.user.id,
          content_type: data.content_type,
          reported_content: data.reported_content,
          reason: data.reason,
          reported_user_id: data.reported_user_id,
          content_id: data.content_id,
          status: 'pending',
          severity: 'medium',
        }]);

      if (error) {
        console.error('Error de Supabase:', error);
        throw error;
      }

      toast({
        title: "Moderación de contenido",
        description: `${data.content_type === 'post' ? 'Tu publicación' : 'Tu comentario'} fue reportado por un miembro de la comunidad y ha sido revisado por nuestro equipo de moderación. Se han tomado las medidas necesarias según nuestras normas comunitarias.`,
        variant: "default",
      });

      return true;
    } catch (error) {
      console.error('Error al crear reporte:', error);
      toast({
        title: "Error al enviar reporte",
        description: "Por favor intenta de nuevo más tarde.",
        variant: "destructive",
      });
      return false;
    }
  };

  return {
    createReport,
  };
}
